import { ComponentType } from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { ability } from '@oliasoft/authorization-ui';
import { NAVIGATION_CONSTANTS } from '../constants';

export interface ICanNavigateRule {
  action: string;
  subject: string;
}

type TRouteOptions = Omit<RouteProps, 'component' | 'render' | 'children'>;

export type TPrivateRouteProps = TRouteOptions & {
  component: ComponentType<never>;
  canNavigate?: ICanNavigateRule | boolean;
  permissions?: object;
  customerEditAction?: string;
  customerEditSubject?: string;
};

export const PrivateRoute = ({
  component,
  canNavigate,
  ...rest
}: TPrivateRouteProps) => {
  const Component = component as ComponentType<RouteComponentProps & typeof rest>;
  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => {
        const rule = typeof canNavigate === 'boolean' ? undefined : canNavigate;
        const hasPermissionToNavigate = canNavigate === true
          ? true
          : ability.can(rule?.action ?? '', rule?.subject ?? '');
        return hasPermissionToNavigate
          ? <Component {...props} {...rest} />
          : <Redirect to={NAVIGATION_CONSTANTS.SETTINGS_ROUTE} />;
      }}
    />
  );
};
